import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldAlert, Building2 } from "lucide-react";
import SEO from "../components/SEO";
import InstantMessagingChat from "../im/InstantMessagingChat";

export default function MssanteMessagerieInstantanee() {
  return (
    <div
      className="bg-[var(--mc-navy-950)] min-h-screen flex flex-col"
      data-testid="page-mssante-messagerie-instantanee"
    >
      <SEO title="Messagerie instantanée · MetaConnect" canonical="/mssante/espace/messagerie-instantanee" noIndex />

      <section className="pt-28 pb-4">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <Link
            to="/mssante/espace"
            data-testid="im-page-back"
            className="text-[11px] uppercase tracking-[0.18em] text-[#0284C7] hover:text-[#0F2B5B] inline-flex items-center gap-1 mb-3"
          >
            <ArrowLeft size={12} /> Retour à mon espace
          </Link>
          <div className="flex items-end justify-between flex-wrap gap-3">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[var(--mc-mint)] mb-1">
                <Building2 size={13} /> Inter-PS · Temps réel
              </div>
              <h1 className="font-display text-white text-3xl sm:text-4xl font-semibold leading-tight">
                Messagerie instantanée
              </h1>
              <p className="mt-2 text-[13px] text-[var(--mc-muted)] max-w-2xl leading-relaxed">
                Échangez rapidement avec vos confrères. Pour tout document médical
                contenant des données de santé, utilisez la{" "}
                <Link to="/mssante/espace" className="text-[#0284C7] underline">Messagerie MSSanté</Link> (HDS).
              </p>
            </div>
          </div>

          <div className="mt-4 rounded-lg border border-[rgba(255,170,80,0.35)] bg-[rgba(255,170,80,0.06)] text-[#B45309] text-[12px] px-4 py-2.5 inline-flex items-center gap-2" data-testid="im-page-hds-notice">
            <ShieldAlert size={14} />
            Pas de pièce jointe ni de donnée patient sur ce canal — environnement non HDS.
          </div>
        </div>
      </section>

      <section className="flex-1 pb-10">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 h-[calc(100vh-260px)] min-h-[520px]">
          <InstantMessagingChat variant="page" />
        </div>
      </section>
    </div>
  );
}
